<template>
  <v-app>
    <v-container fill-height>
      <v-layout fill-height column justify-center align-center>
        <v-progress-circular indeterminate />
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Login",
  created() {
    this.logIn(this.$route.query.token);
  },
  methods: {
    ...mapActions({
      logIn: "auth/logIn"
    })
  }
};
</script>
